import { render, staticRenderFns } from "./StudentTransfer.vue?vue&type=template&id=771bcd28&scoped=true"
import script from "./StudentTransfer.vue?vue&type=script&lang=js"
export * from "./StudentTransfer.vue?vue&type=script&lang=js"
import style0 from "./StudentTransfer.vue?vue&type=style&index=0&id=771bcd28&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771bcd28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('771bcd28')) {
      api.createRecord('771bcd28', component.options)
    } else {
      api.reload('771bcd28', component.options)
    }
    module.hot.accept("./StudentTransfer.vue?vue&type=template&id=771bcd28&scoped=true", function () {
      api.rerender('771bcd28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentTransfer.vue"
export default component.exports